<template>
    <div class="treeview-area">
        <div class="container-fluid">
            <div class="timeline card-box-style">
                <div class="others-title">
                    <h3>Treeview</h3>
                </div>

                <div class="treeview js-treeview scroll-bar">
                    <ul>
                        <li>
                            <div class="treeview__level" data-level="A">
                                <span class="level-title">Level A</span>
                                <div class="treeview__level-btns">
                                    <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                    <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                    <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                    <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                </div>
                            </div>
                            <ul>
                                <li>
                                    <div class="treeview__level" data-level="B">
                                        <span class="level-title">Level A</span>
                                        <div class="treeview__level-btns">
                                            <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                            <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                            <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                            <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                        </div>
                                    </div>
                                    <ul>
                                        <li>
                                            <div class="treeview__level" data-level="C">
                                                <span class="level-title">Level A</span>
                                                <div class="treeview__level-btns">
                                                    <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                                    <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                                    <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                                    <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                                </div>
                                            </div>
                                            <ul>
                                                <li>
                                                    <div class="treeview__level" data-level="D">
                                                        <span class="level-title">Level A</span>
                                                        <div class="treeview__level-btns">
                                                            <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                                            <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                                            <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                                            <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                                        </div>
                                                    </div>
                                                    <ul></ul>
                                                </li>
                                            </ul>
                                        </li>
                        
                                        <li>
                                            <div class="treeview__level" data-level="C">
                                                <span class="level-title">Level A</span>
                                                <div class="treeview__level-btns">
                                                    <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                                    <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                                    <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                                    <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                                </div>
                                            </div>
                                            <ul></ul>
                                        </li>
                        
                                        <li>
                                            <div class="treeview__level" data-level="C">
                                                <span class="level-title">Level A</span>
                                                <div class="treeview__level-btns">
                                                    <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                                    <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                                    <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                                    <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                                </div>
                                            </div>
                                            <ul></ul>
                                        </li>
                                    </ul>
                                </li>
                        
                                <li>
                                    <div class="treeview__level" data-level="B">
                                        <span class="level-title">Level A</span>
                                        <div class="treeview__level-btns">
                                            <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                                            <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                                            <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                                            <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                                        </div>
                                    </div>
                                    <ul></ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
                    
            <template id="levelMarkup">
                <li>
                    <div class="treeview__level" data-level="A">
                        <span class="level-title">Level A</span>
                        <div class="treeview__level-btns">
                            <div class="btn btn-default btn-sm level-add"><span class="bx bx-plus"></span></div>
                            <div class="btn btn-default btn-sm level-remove"><span class="bx bx-trash-alt text-danger"></span></div>
                            <div class="btn btn-default btn-sm level-same"><span>Add Same Level</span></div>
                            <div class="btn btn-default btn-sm level-sub"><span>Add Sub Level</span></div>
                        </div>
                    </div>
                    <ul></ul>
                </li>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TreeviewContent'
}
</script>

<style lang="scss">
.treeview {
	height: 780px;
    .btn-default {
        border-color: #e3e5ef;
		&.level-same {
			width: 150px;
			left: 90px;
			padding: 10px 5px;
			background-color: var(--main-color);
			color: var(--white-color);
			&:hover {
				background-color: var(--main-color);
				color: var(--white-color);
			}
		}
		&.level-sub {
			width: 150px;
			left: 0;
			top: 57px;
			padding: 10px 5px;
			background-color: var(--main-color);
			color: var(--white-color);
			&:hover {
				background-color: var(--main-color);
				color: var(--white-color);
			}
		}
		&:hover {
			background-color: #f7faea;
			color: var(--main-color);
		}
    }

	ul {
		list-style: none;
		padding-left: 32px;
		li {
			padding: 50px 0px 0px 35px;
			position: relative;
			&:before {
				content: "";
				position: absolute;
				top: -26px;
				left: -31px;
				border-left: 2px dashed #a2a5b5;
				width: 1px;
				height: 100%;
			}
			&:after {
				content: "";
				position: absolute;
				border-top: 2px dashed #a2a5b5;
				top: 70px;
				left: -30px;
				width: 65px;
			}
			&:last-child:before {
				top: -22px;
				height: 90px;
			}
		}
	}
	& > ul {
		& > li {
			&:after,
			&:last-child:before {
				content: unset;
			}
			&:before {
				top: 90px;
				left: 36px;
			}
			&:not(:last-child) > ul > li {
				&:before {
					content: unset;
				}
			}
			& > .treeview__level {
				&:before {
					height: 60px;
					width: 60px;
					top: 0.5px;
					background-color: #54a6d9;
					border: 7.5px solid #d5e9f6;
					font-size: 22px;
				}
			}
			& > ul {
				padding-left: 34px;
			}
		}
	}
	&__level {
		padding: 7px;
		padding-left: 70px;
		display: inline-block;
		border-radius: 5px;
		font-weight: 700;
		border: 1px solid #e3e5ef;
		position: relative;
		z-index: 1;

		&:before {
			content: attr(data-level);
			position: absolute;
			left: -25px;
			top: 2.5px;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 55px;
			width: 55px;
			border-radius: 50%;
			border: 7.5px solid #eef6d5;
			background-color: var(--main-color);
			color: #fff;
			font-size: 20px;
		}

		&-btns {
			margin-left: 15px;
			display: inline-block;
			position: relative;
		}

		.level {
			&-same,
			&-sub {
				position: absolute;
				display: none;
				transition: opacity 250ms cubic-bezier(0.7, 0, 0.3, 1);
				&.in {
				display: block;
				.btn-default {
						background-color: #faeaea;
						color: #da5555;
					}
				}
			}

			&-same {
				top: 0;
				left: 45px;
			}
			&-sub {
				top: 42px;
				left: 0px;
			}
			&-remove {
				display: none;
			}
		}

		&.selected {
			background-color: #f9f9fb;
			box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.10);
			.level {
				&-remove {
				display: inline-block;
				}
				&-add {
				display: none;
				}
				&-same,
				&-sub {
				display: none;
				}
			}
		}
	}
	.level-title {
		cursor: pointer;
		user-select: none;
		&:hover {
			text-decoration: underline;
		}
    }
	&--mapview {
		ul {
			justify-content: center;
			display: flex;
			li {
				&:before {
					content: unset;
				}

				&:after {
					content: unset;
				}
			}
		}
	}
}
</style>